import { SupportedLeadCardType } from 'cards/types/supportedLeadCardTypes';
import type { SEOData, FilterSEOData } from '../types';
import type { AllFilters } from '../filters';
import { CARD_TYPE_COPY } from './unfiltered';
import { FILTERED_INVITATIONS_COPY } from './filtered/invitations';
import { FILTERED_STD_COPY } from './filtered/std';

// Filtered SEO data overrides are defined by card type, then filter key.
const FILTERED_COPY_BY_CARD_TYPE: { [k in SupportedLeadCardType]?: FilterSEOData } = {
  INVITATION: FILTERED_INVITATIONS_COPY,
  SAVE_THE_DATE: FILTERED_STD_COPY,
};

export const getOptionalSEO = (
  typeKey: SupportedLeadCardType | undefined,
  filterKey: AllFilters | undefined
): Partial<SEOData> => {
  // Don't return any copy if no card type is available.
  if (!typeKey) return {};

  // If there is a single filter selected, return filter-specific copy.
  if (filterKey) {
    const overrides = FILTERED_COPY_BY_CARD_TYPE[typeKey]?.[filterKey];
    return overrides || {};
  }

  // If no filters are selected, return the card type's default copy.
  return CARD_TYPE_COPY[typeKey] || {};
};
